const routes = [
    {
        path: '/',
        component: () => import('../views/Inicio'),
    },
    {
        path: '/atendimentos/inicio',
        component: () => import('../views/Inicio'),
    },
    {
        path: '/atendimentos/sistema/inicio',
        component: () => import('../views/Inicio'),
    },
   
]


export default routes